import axios from 'axios';
const axiosPublic = axios.create();

// Obtener encuesta por token (sin autenticación)
export const obtenerEncuestaPorToken = (token) => {
  return new Promise((resolve, reject) => {
    axiosPublic.get(`/public/encuestas/${token}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al obtener encuesta pública:', error);
        reject(error);
      });
  });
};

// Enviar respuestas de encuesta pública
export const enviarRespuestaEncuestaPublica = (token, datosRespuesta) => {
  return new Promise((resolve, reject) => {
    axiosPublic.post(`/public/encuestas/${token}/responder`, datosRespuesta)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al enviar respuesta de encuesta pública:', error);
        reject(error);
      });
  });
};
